import { type AxiosError } from 'axios'
import { analiticaInstance } from 'shared/analitica'

export const infraEvents = analiticaInstance.eventFactory('Infra', {
  httpClientFactory: {
    /**
     * @analitica Quando há algum erro no request interceptor
     */
    errorRequestInterceptor: (error: unknown | any) => ({
      label: 'request.interceptor.error',
      description: 'Erro no request interceptor',
      errorInterceptor: error
    }),
    /**
     * @analitica Quando há algum erro no response interceptor
     */
    errorResponseInterceptor: (error: AxiosError) => ({
      label: 'response.interceptor.error',
      description: 'Erro no response interceptor',
      error: {
        name: error.name,
        message: error.message,
        status: error.code
      }
    })
  }
})
